import React from 'react';

export interface ClientCellData {
    clientName?: string
    clientId?: number
}

export const ClientCell = <T extends ClientCellData>(row: T) => {
    const value = row?.clientName || row?.clientId || 'Unknown'

    return (
        <>{value}</>
    );
};